const ORANGE = "#D9481C";
const RED = "#E1380B";

export const LogoMark = ({ className = "h-8 w-8", stroke = "#1C1917", dot = RED }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <line x1="4" y1="34" x2="56" y2="34" stroke={stroke} strokeWidth="1.6" />
    <line x1="4" y1="31" x2="4" y2="37" stroke={stroke} strokeWidth="1.6" />
    <line x1="56" y1="31" x2="56" y2="37" stroke={stroke} strokeWidth="1.6" />
    <line x1="22" y1="8" x2="22" y2="58" stroke={stroke} strokeWidth="1.6" />
    <line x1="19" y1="8" x2="25" y2="8" stroke={stroke} strokeWidth="1.6" />
    <line x1="19" y1="58" x2="25" y2="58" stroke={stroke} strokeWidth="1.6" />
    <path d="M22 20 Q25.5 30.5 36 34 Q25.5 37.5 22 48 Q18.5 37.5 8 34 Q18.5 30.5 22 20 Z" fill={stroke} />
    <circle cx="47" cy="11" r="4" fill={dot} />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark stroke={dark ? "#FAFAF9" : "#1C1917"} className="h-9 w-9 shrink-0" />
    <span className="flex flex-col leading-none">
      <span className="font-label text-[14px] font-extrabold tracking-[0.3em]" style={{ color: ORANGE }}>
        ORIGIN
      </span>
      <span className="mt-1.5 font-label text-[11px] font-extrabold tracking-[0.44em]" style={{ color: ORANGE }}>
        BUREAU
      </span>
    </span>
  </span>
);
